import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TeamsListLayer from "../components/TeamsListLayer";

const TeamsListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Work Teams">

        {/* TeamsListLayer */}
        <TeamsListLayer />
      </MasterLayout>
    </>
  );
};

export default TeamsListPage;
